<template>
    <li>
        <div class="bax-collapse">
            <div class="bax-collapse-header d-md-flex align-items-center" @click="toggle">
              <strong v-if="isTPN()">
                <i :title="getDrugStatusTitle(drug.status)" :class="'bax-order-status-icon' + ' ' + getDrugStatusIcon(drug.status)"></i> {{ drug.description }}
            </strong>
              <strong v-else>
                <!-- {{ drug.drug1Name }} -->
                <i :title="getDrugStatusTitle(drug.status)" :class="'bax-order-status-icon' + ' ' + getDrugStatusIcon(drug.status)"></i>
                {{ drug.order_line_type === 'FP' && drug.drug1GenericName !== '' ? drug.drug1GenericName : drug.drug1Name || drug.drug1_name || drug.drugName }}
                {{ drug.order_line_type === 'FP' && drug.drug1Name !== '' ? drug.drug1Name : drug.drug1_name || drug.drugName }}
                {{ drug.drug2Name?'& ' + drug.drug2Name:'' }}
                <span v-if="drug.order_line_type === 'FP' && typeof drug.drug2GenericName !== 'undefined' && drug.drug2GenericName !== '' && (drug.drug2GenericName)">& {{ drug.drug2GenericName }}</span>
                <span v-if="onHold" class="text-sm text-yellow-500">- ON HOLD</span>
              </strong>
                <span class="ml-auto d-block mt-3 mt-md-0">
                    {{ open ? 'Hide' : 'Show' }} Details<i v-bind:class="[open ? 'icon-chevron-down' : 'icon-chevron-up']"></i>
                </span>
            </div>
<!--            <div class="bax-order-status" v-if="open">-->
<!--                <div class="d-flex align-items-center">-->
<!--                    <i :class="getDrugStatusIcon(drug.status)"></i>-->
<!--                    {{ getDrugStatusTitle(drug.status) || '' }}-->
<!--                </div>-->
<!--            </div>-->
        </div>
        <div class="bax-order-summary" v-if="open">
            <ul>
                <template v-if="authenticatedUser.baxterRoles.can_create_edit_orders">
                    <li class="d-flex align-items-center bax-order-summary-info" v-if="drug.canOrderLineBeEdited == 'false' || !drug.canOrderLineBeEdited">
                        <i class="icon-info-bg"></i>
                        The item cannot be edited because it has been {{ getDrugStatus(drug.status) }}.
                    </li>
                    <li class="d-md-flex bax-order-summary-actions">
                        <div class="d-flex align-items-center" v-if="drug.order_line_type !== 'FP'">
                            <strong class="mr-4">On Hold</strong>
                            <div class="can-toggle">
                                <input :id="'b' + randId" type="checkbox" v-model="onHold" @change="onHoldChange" :disabled="!drug.on_hold_can_change">
                                <label :for="'b' + randId">
                                    <div class="can-toggle__switch" data-checked="On" data-unchecked="Off"></div>
                                </label>
                            </div>
                        </div>
                        <div class="ml-auto">
                            <a href="#" v-if="drug.canOrderLineBeCancelled === 'true' || drug.canOrderLineBeCancelled === true" @click.prevent="onCancel" class="bax-btn bax-btn-orange-1">
                                Cancel
                            </a>
                            <a href="#" v-if="drug.canOrderLineBeEdited  === 'true' || drug.canOrderLineBeEdited === true" @click.prevent="onEdit" class="bax-btn bax-btn-blue">
                                <i class="icon-edit"></i>Edit
                            </a>
                        </div>
                    </li>
                </template>
              <li class="d-md-flex" v-if="drug.description">
                <span>Product:</span>
                <strong class="ml-auto text-md-right">{{ drug.description }}</strong>
              </li>
              <li class="d-md-flex" v-if="drug.finishedProductCode">
                <span>Product Code:</span>
                <strong class="ml-auto text-md-right">{{ drug.finishedProductCode }}</strong>
              </li>
                <li class="d-md-flex" v-if="drug.overrideStability || drug.overrideDosage">
                    <span>Alerts: </span>
                    <strong class="ml-auto text-md-right">
                        <span v-if="drug.overrideStability">No system stability exists for this drug</span>
                        <span v-if="drug.overrideDosage">Max dosage exceeded for this drug</span>
                    </strong>
                </li>
                <li class="d-md-flex">
                    <span>Qty: </span>
                    <strong class="ml-auto text-md-right">{{ drug.quantity }}</strong>
                </li>
                <template v-if="!isTPN()">
                  <li class="d-md-flex" v-if="drug.drug1Dose && !drug.drug2Dose">
                      <span>Dose: </span>
                      <strong class="ml-auto text-md-right">{{ rounddec_2(drug.drug1Dose)}} {{ drug.drug1UOM }}</strong>
                  </li>
                  <li class="d-md-flex" v-if="drug.drug2Dose">
                    <span>Dose {{ drug.order_line_type === 'FP' ? drug.drug1GenericName : drug.drug1Name }}: </span>
                      <strong class="ml-auto text-md-right">{{ rounddec_2(drug.drug1Dose)}} {{ drug.drug1UOM }}</strong>
                  </li>
                  <li class="d-md-flex" v-if="drug.drug2Dose">
                    <span>Dose {{ drug.order_line_type === 'FP' ? drug.drug2GenericName : drug.drug2Name }}: </span>
                      <strong class="ml-auto text-md-right">{{ rounddec_2(drug.drug2Dose)}} {{ drug.drug2UOM }}</strong>
                  </li>
                  <li class="d-md-flex">
                      <span>Route: </span>
                      <strong class="ml-auto text-md-right">{{ drug.administrationRouteDescription }}</strong>
                  </li>

                <li class="d-md-flex">
                  <span>Container: </span>
                  <strong class="ml-auto text-md-right">
                    {{ drug.deviceGenericName ? drug.deviceGenericName : (drug.container ? drug.container : drug.containerTypeName) }}
                  </strong>
                </li>
              </template>
              <li class="d-md-flex" v-if="(typeof drug.diluentGenericName !== 'undefined' && drug.diluentGenericName != '') || (drug.diluent && drug.diluent != '')">
                <span>Diluent:</span>
                <strong class="ml-auto text-md-right">{{ drug.diluentGenericName?drug.diluentGenericName:drug.diluent }}</strong>
              </li>
                <li class="d-md-flex">
                    <span>Total vol:</span>
                    <strong class="ml-auto text-md-right">{{ rounddec_2(drug.totalVolume) }} mL</strong>
                </li>
                <li class="d-md-flex" v-if="drug.infusionTime > 0.001">
                    <span>Infusion time: </span>
                    <strong class="ml-auto text-md-right">{{ rounddec_2(drug.infusionTime) }} {{ drug.infusionTimeDuration?drug.infusionTimeDuration:'hours' }}</strong>
                </li>
              <li class="d-md-flex" v-if="(drug.customerRequiredDate) && (drug.customerRequiredDate !== '') || (drug.dateRequiredFormatted) && (drug.dateRequiredFormatted !== '')">
                <span>Date Required: </span>
                <strong class="ml-auto text-md-right d-md-flex">
                  {{ convertCustomerRequiredDate() }}</strong>
              </li>
              <li class="d-md-flex" v-if="(drug.stabilityStorage) && (drug.stabilityStorage !== '')">
                <span>Stability: </span>
                <strong class="ml-auto text-md-right d-md-flex">
                  {{ drug.stabilityStorage }} {{ drug.stabilityUOM }} {{ drug.stabilityStorageType }} </strong>
              </li>
                <li class="d-md-flex" v-if="(drug.administrationDateFormatted) && (drug.administrationDateFormatted !== '')">
                    <span>Treatment Date: </span>
                    <strong class="ml-auto text-md-right d-md-flex">
                        {{ drug.administrationDateFormatted }}</strong>
                </li>
                <li class="d-md-flex" v-if="((drug.ancillary1GenericName) && (drug.ancillary1GenericName !== '')) || (drug.ancillary1Name) || (drug.ancillary2Name)">
                    <span>Ancillary: </span>
                    <strong class="ml-auto text-md-right" v-if="drug.order_line_type === 'FP'">
                        {{ drug.ancillary1GenericName ? drug.ancillary1GenericName : '' }}
                        {{ drug.ancillary2GenericName ? ', ' + drug.ancillary2GenericName : '' }}
                    </strong>
                    <strong class="ml-auto text-md-right" v-else>
                        {{ drug.ancillary1Name ? drug.ancillary1Name : '' }}
                        {{ drug.ancillary2Name ? ', ' + drug.ancillary2Name : '' }}
                    </strong>
                </li>
            </ul>
        </div>
        <br v-if="open" />
    </li>
</template>

<script>
import OrderService from '@/core/api/order/order.service';
import utilsMixin from '@/mixins/utilsMixin';
import moment from 'moment';
import tpnMixin from '@/mixins/tpnMixin';
import { mapGetters } from 'vuex';

export default {
    name: 'DrugList',
  mixins: [utilsMixin, tpnMixin],
  props: ['drug'],
    data() {
        return {
            open: false,
            randId: '',
            onHold: false,
        };
    },
    computed: {
        ...mapGetters(['authenticatedUser']),
    },
    created() {
        this.randId = this.getRandomInt(999999);
    },
    mounted() {
      if (this.drug.onHold === '0') {
        this.onHold = false;
      } else if (this.drug.onHold === false) {
        this.onHold = false;
        } else {
            this.onHold = true;
        }
    },
  updated() {
      // When sorting the drug list, the drug is updated a few times. Need to keep track of the onHold status
    if (this.drug.onHold === '0') {
      this.onHold = false;
    } else if (this.drug.onHold === false) {
      this.onHold = false;
    } else {
      this.onHold = true;
    }
  },
    methods: {
        convertCustomerRequiredDate() {
            if (this.drug.customerRequiredDate) {
                return moment(this.drug.customerRequiredDate).format('DD/MM/YYYY');
            }
            if (!(this.drug.customerRequiredDate)) {
                return this.drug.dateRequiredFormatted;
            }
            return '--';
        },
        openDetails() {
            this.open = true;
            this.$emit('item-open');
        },
        closeDetails() {
            this.open = false;
            this.$emit('item-close');
        },
        toggle() {
            if (this.open) {
                this.closeDetails();
            } else {
                this.openDetails();
            }
        },
        getDrugStatus(status) {
            if (status && status.toLowerCase() === ('Cancelled').toLowerCase()) {
                return 'cancelled';
            }

            if (this.onHold) {
                return 'placed on hold';
            }
            if ((status && status.toLowerCase() === ('In manufacture').toLowerCase()) || (status && status.toLowerCase() === ('Manufactured').toLowerCase())) {
                return 'manufactured';
            }

            if (status && status.toLowerCase() === ('Dispatched').toLowerCase()) {
                return 'shipped';
            }

            if (status && status.toLowerCase() === ('Shipped').toLowerCase()) {
                return 'shipped';
            }

            if ((status && status.toLowerCase() === ('Reviewed').toLowerCase()) || (status && status.toLowerCase() === ('Received').toLowerCase())) {
                return 'reviewed';
            }

            if (status && status.toLowerCase() === ('Pending').toLowerCase()) {
                return 'pending';
            }

            return '';
        },
        getDrugStatusTitle(status) {
            if (status && status.toLowerCase() === ('Cancelled').toLowerCase()) {
                return 'Cancelled';
            }

            if (this.onHold) {
                return 'On Hold';
            }

            if ((status && status.toLowerCase() === ('In manufacture').toLowerCase()) || (status && status.toLowerCase() === ('Manufactured').toLowerCase())) {
                return 'In Manufacture';
            }

            if (status && status.toLowerCase() === ('Dispatched').toLowerCase()) {
                return 'Shipped';
            }

            if (status && status.toLowerCase() === ('Shipped').toLowerCase()) {
                return 'Shipped';
            }

            if ((status && status.toLowerCase() === ('Reviewed').toLowerCase()) || (status && status.toLowerCase() === ('Received').toLowerCase())) {
                return 'Reviewed';
            }

            if (status && status.toLowerCase() === ('Pending').toLowerCase()) {
                return 'Pending';
            }

            if (status && status.toLowerCase() === ('NONBOLT').toLowerCase()) {
                return 'This order can not be edited because it is not a BOLT order';
            }

            return '';
        },
        getDrugStatusIcon(status) {
            if (status && status.toLowerCase() === ('Cancelled').toLowerCase()) {
                return 'icon-cancel';
            }

            if (this.onHold) {
                return 'icon-onhold';
            }

            if ((status && status.toLowerCase() === ('Reviewed').toLowerCase()) || (status && status.toLowerCase() === ('Received').toLowerCase())) {
                return 'icon-reviewd';
            }

            if (status && status.toLowerCase() === ('Pending').toLowerCase()) {
                return 'icon-pending';
            }

            if (status && status.toLowerCase() === ('Dispatched').toLowerCase()) {
                return 'icon-dispatched';
            }

            if (status && status.toLowerCase() === ('Shipped').toLowerCase()) {
                return 'icon-dispatched';
            }

            if ((status && status.toLowerCase() === ('In manufacture').toLowerCase()) || (status && status.toLowerCase() === ('Manufactured').toLowerCase())) {
                return 'icon-manufactured';
            }

            return status;
        },
        getRandomInt(max) {
            return Math.floor(Math.random() * Math.floor(max));
        },
        onEdit() {
          this.$emit('edit-drug', this.drug);
        },
        onCancel() {
            this.$emit('cancel-drug', this.drug);
        },
        onHoldChange() {
            let holdDrugName = this.drug.drug1Name;
            if (this.drug.drug2Name) {
                holdDrugName = holdDrugName + ' & ' + this.drug.drug2Name;
            }
          this.drug.onHold = this.onHold;
            const data = {
                merlinOrderID: this.drug.merlinOrderID,
                merlinOrderLineID: this.drug.merlinOrderLineID ? this.drug.merlinOrderLineID : this.drug.orderLineId,
                orderLineId: this.drug.orderLineId,
                groupOrderID: this.drug.groupOrderID,
                type: this.drug.order_line_type,
                onHold: this.onHold,
                drugName: holdDrugName,
            };
            OrderService.updateOrder(data)
                .then(() => {
                    //
                })
                .catch(() => {
                    if (this.onHold === true) {
                        this.onHold = false;
                    } else {
                        this.onHold = true;
                    }
                })
                .then(() => {
                    this.$Progress.finish();
                   // this.$emit('order-changed');
                });
        },
    },
};
</script>

<style scoped>
.drug-status {
    padding-left: 5px;
}
</style>
